module.exports = __webpack_public_path__ + "media/small/real_estate_homes_rent-small-9d930c20.jpeg";